import classNames from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import useApplicationData from 'src/hooks/useApplicationData';
import useSubtitle from 'src/hooks/useSubtitle';
import useUI from 'src/hooks/useUI';
import { IconSize } from 'src/interfaces/Icon';
import { detectMobile } from 'src/utils/browserUtils';
import Chip from '../../components/Chip';
import SubtitleToggle from '../../components/SubtitleToggle';
import Description from '../../components/Text/Description';
import Title from '../../components/Text/Title';
import styles from './styles.module.scss';

export interface IHeaderProps {
  title?: string;
  description?: string;
}

const Header = ({ title, description }: IHeaderProps) => {
  const { subtitleEnabled, subtitles } = useSubtitle();
  const { platformUserId, flags } = useApplicationData();
  const { toggleSubtitleSettings } = useUI();

  const { t } = useTranslation('common');
  const isMobile = detectMobile();

  return (
    <div className={classNames(styles.container, { [styles.mobile]: isMobile })} data-testid='header'>
      <div className={classNames(styles.column, styles.leftSide)}>
        {title && <Title>{title}</Title>}
        {description && <Description>{description}</Description>}
        {platformUserId && flags.ENABLE_PLAYER_DISPLAY_USER_ID && (
          <Chip
            className={styles.platformUserId}
            text={t('general.userId', {
              id: platformUserId,
            })}
          />
        )}
      </div>
      <div className={classNames(styles.column, styles.rightSide)}>
        <div className={classNames(styles.mobileOnly, { [styles.show]: isMobile })}>
          {subtitles && (
            <SubtitleToggle iconSize={IconSize.small} isEnabled={subtitleEnabled} onClick={toggleSubtitleSettings} />
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
